import AvButton from './AvButton'
import AtlasIcon from '../atlasVivo/AtlasIcon'
import './nediAnatomy.css'
import '../atlasVivo/Buttons.css'

/** Empty / error chrome using Nedi panel radius + AvButton CTA (`<nedi-button>`). */
export default function NediEmptyState({
  icon,
  iconName,
  title,
  message,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  compact = false,
  className = '',
  actionVariant = 'primary',
  secondaryActionVariant = 'ghost',
}) {
  const resolvedIcon = iconName || icon
  const showPrimary = Boolean(actionLabel && onAction)
  const showSecondary = Boolean(secondaryActionLabel && onSecondaryAction)

  return (
    <div
      className={`nedi-empty${compact ? ' nedi-empty--compact' : ''}${className ? ` ${className}` : ''}`}
      role="status"
      data-nedi-anatomy="empty"
    >
      {resolvedIcon ? (
        <div className="nedi-empty__icon" aria-hidden="true">
          {typeof resolvedIcon === 'string' ? (
            <AtlasIcon name={resolvedIcon} size={compact ? 22 : 28} />
          ) : (
            resolvedIcon
          )}
        </div>
      ) : null}
      {title ? <h3 className="nedi-empty__title">{title}</h3> : null}
      {message ? <p className="nedi-empty__message">{message}</p> : null}
      {showPrimary || showSecondary ? (
        <div className="nedi-empty__actions">
          {showPrimary ? (
            <AvButton type="button" variant={actionVariant} onClick={onAction}>
              {actionLabel}
            </AvButton>
          ) : null}
          {showSecondary ? (
            <AvButton type="button" variant={secondaryActionVariant} onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </AvButton>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
